import React, { useState } from 'react';
import { colors, mobileMQ } from '../../modules/theme';
import SpeciesContent from '../species-content';
import LGAContent from '../lga-content';
import useGlobalState from '../../hooks/use-global-state';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDotCircle } from '@fortawesome/pro-solid-svg-icons';
const tabs = ['Species', 'LGA'];

export const sidebarWidth = 370;

export default function Sidebar() {
  const [activeTab, setActiveTab] = useState(tabs[0]);
  const { state } = useGlobalState();

  return (
    <div
      css={{
        width: sidebarWidth,
        flexShrink: 0,
        marginLeft: 2.5,
        display: 'flex',
        flexDirection: 'column',
        background: colors.darkBlue,
        borderRadius: '4px',
        [mobileMQ]: {
          position: 'absolute',
          top: 0,
          bottom: 0,
          right: 0,
        },
      }}
    >
      <ul
        css={{
          display: 'flex',
          listStyle: 'none',
          minHeight: 41,
        }}
      >
        {tabs.map((tab, i) => {
          return (
            <li
              css={{
                width: '50%',
                color: 'white',
                fontWeight: 600,
                fontSize: 18,
                textAlign: 'center',
                borderRadius: '4px 4px 0 0',
                padding: 10,
                marginRight: i === 0 ? 2.5 : 0,
                cursor: 'pointer',
                background: activeTab === tab ? colors.darkBlue : colors.blue,
              }}
              key={tab}
              onClick={() => setActiveTab(tab)}
            >
              {tab}
              {tab === 'LGA' && state.lga && (
                <FontAwesomeIcon
                  css={{
                    fontSize: '9px',
                    position: 'absolute',
                  }}
                  icon={faDotCircle}
                />
              )}
              {tab === 'Species' && state.activeFrogType && (
                <FontAwesomeIcon
                  css={{
                    fontSize: '9px',
                    position: 'absolute',
                  }}
                  icon={faDotCircle}
                />
              )}
            </li>
          );
        })}
      </ul>
      {activeTab === 'LGA' ? <LGAContent /> : <SpeciesContent />}
    </div>
  );
}
